var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.666,
    height: 27.704,
    viewBox: "0 0 30.666 27.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#666;stroke-width:1.3px;}.b{stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.65 0.65)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.32,39.491a13.153,13.153,0,0,0,8.922-3.56l2.851-.02,3.817-.027-1.932-3.293-1.235-2.105a13.2,13.2,0,1,0-12.424,9Z",
    transform: "translate(-7.025 -13.087)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 15.691,
    transform: "translate(5.825 13.001)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 15.692,
    transform: "translate(13.67 5.356)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProduct);
export default __webpack_public_path__ + "static/media/add_product.b2b546a357e2dacb002c7b1e12ead1ac.svg";
export { ForwardRef as ReactComponent };